import { jsx as _jsx } from "react/jsx-runtime";
import { HorizontalLoaderX as HorizontalLoader } from "../../assets/graphics";
import styled from "@emotion/styled";
const Container = styled.div(`
svg {
    margin: 0 auto;
    width: 100%;
    color: #9a8734;
    -webkit-animation-name: load;
    -webkit-animation-duration: 1000ms;
    -webkit-animation-iteration-count: infinite;
    -webkit-animation-timing-function: linear;
    -moz-animation-name: load;
    -moz-animation-duration: 1000ms;
    -moz-animation-iteration-count: infinite;
    -moz-animation-timing-function: linear;
    -ms-animation-name: load;
    -ms-animation-duration: 1000ms;
    -ms-animation-iteration-count: infinite;
    -ms-animation-timing-function: linear;
    animation-name: load;
    animation-duration: 1000ms;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
}

svg path {
  fill: var(--brand-color);
}

#dots #dot1{
  animation: load 1s infinite;
}

#dots #dot2{
  animation: load 1s infinite;
  animation-delay: 0.2s;
}

#dots #dot3{
  animation: load 1s infinite;
  animation-delay: 0.4s;
}

@keyframes load{
  0%{
    opacity: 0;
  }
  50%{
    opacity: 1;
  }
  100%{
    opacity: 0;
  }
`);
export default function LoaderLifestyleHorizontal() {
    return /*#__PURE__*/ _jsx(Container, {
        children: /*#__PURE__*/ _jsx(HorizontalLoader, {})
    });
}
